<template>
  <div id="App" class="patternlib-root" theme="hau">
    <patternlib-toast ref="globalToast" position="top-right"/>
    <div style="
      width: 100%;
      background-color: var(--color-artic-blue);
      padding: var(--spacing-4) 0px;
      margin-bottom: 96px;
    "
    v-if="authStore.legalConformation">
      <div style="margin-left: 5%">
        <patternlib-headline :headline="$t('menuBar.headline')" heading-tag="h6" separator="none" style="color: var(--color-white);"></patternlib-headline>
      </div>
      <div id="shadow" style="position: relative;">
        <div id="scrollBox">
          <div style="
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;
            gap: var(--spacing-4);
            width: 600px;
            margin: 0px 5%;
          ">
            <router-link to="/home"><subnavItem :name="$t('menuBar.overview')" :active="$route.path == '/home'"/></router-link>
            <router-link to="/myOrders" v-if="globalStore.showOrders">
              <subnavItem :name="$t('myOrders.headline')" :active="$route.path == '/myOrders'"/>
            </router-link>
            <router-link to="/myAppliances">
              <subnavItem :name="$t('menuBar.myAppliances')" :active="$route.path == '/myAppliances'"/>
            </router-link>
            <router-link to="/myAccount"><subnavItem :name="$t('myData')" :active="$route.path == '/myAccount'"/></router-link>
            <router-link to="/logout"><subnavItem :name="$t('menuBar.logout')" :active="$route.path == '/logout'"/></router-link>
          </div>
        </div>
      </div>
    </div>
    <div>
      <router-view @showMessage="(toastData) => emitMessage(toastData)"></router-view>
    </div>
  </div>
</template>

<script>
import subnavItem from "./components/subnavItem.vue"
import { useGlobal } from "./stores/globalStore"
import { useAuth } from "./stores/authStore"
import { useServices } from "./services/useServices";

export default {
  data: () => ({
    // localization
    localization: {
      localeId: "de_DE",
      countryId: "DE",
      language: "de",
    },
    // env variable
    isLoggedIn: false,
    toastId: 0
  }),

  components: {
    subnavItem
  },

    computed: {
      authStore: () => useAuth(),
      globalStore: () => useGlobal()
    },

  watch: {

  },

  methods: {
    // getAccessoryShopUrl(globalStore) {
    //   //globalStore.accessoryShopUrl = '/de-at/shop/accessory';

    //   const services = useServices();
    //   services.$api.getDwlConfigurationPage((res) => {
    //     console.log(res);
    //     globalStore.accessoryShopUrl = res;
    //   }, globalStore.language, globalStore.country, 'Accessory', window.location.origin);
    // },
    // localization
    readLanguageAndCountryFromUrl(globalStore) {
      // set language based on url
      const urlPath = window.location.pathname; // default DE,
      // const urlPath = "/en/gbr/home/homepage.html"; // TEST: GB

      // const matched = urlPath.match(
      //   /\/(?<language>[A-Za-z]{2})\/(?<countryIsoAlpha3>[A-Za-z]{3})/is
      // );

      // DWL is using the following language country: de-at
      const matched = urlPath.match(
        /\/(?<language>[a-z]{2})-(?<countryIsoAlpha2>[a-z]{2})\//
      );

      if (matched && matched.length && matched.groups) {
        const language = matched.groups.language;
        //const countryIsoAlpha3 = matched.groups.countryIsoAlpha3;
        //const countryIsoAlpha2 = alpha3ToAlpha2(countryIsoAlpha3.toUpperCase());
        const countryIsoAlpha2 = matched.groups.countryIsoAlpha2 ? matched.groups.countryIsoAlpha2.toUpperCase() : null
        //const countryIsoAlpha3 = alpha2ToAlpha3(countryIsoAlpha2);

        if (language && countryIsoAlpha2) {
          this.localization.language = language;
          this.localization.countryId = countryIsoAlpha2;
          this.localization.localeId = `${language}_${countryIsoAlpha2}`;
          this.$i18n.locale = this.localization.localeId

          // Fallback: If locale does not exist, locale will be set to a locale wich has the same language
          if ( !this.$i18n.availableLocales.includes(this.localization.localeId) ){
            this.$i18n.availableLocales.forEach(locale => {
              if (locale.startsWith(this.localization.language)){
                this.$i18n.locale = locale
              }
            });
          }

          globalStore.language = language
          globalStore.country = countryIsoAlpha2
        }
      }
      else {
        // Running on http://localhost:8080
        const countryIsoAlpha2 = 'at';
        const language = 'de';
        const countryId = 'at';
        this.localization.language = language;
        this.localization.countryId = countryId;
        this.localization.localeId = `${language}_${countryIsoAlpha2}`;
        this.$i18n.locale = this.localization.localeId;
        globalStore.language = language
        globalStore.country = countryIsoAlpha2
        // console.log(`Language: ${language}`);
        // console.log(`Country: ${countryId}`);
      }
    },
    
    emitMessage(toastData) {
      this.toastId+=1
      toastData["itemId"] = this.toastId.toString()
      this.$refs.globalToast.createToastItem(toastData)
    }
  },

  mounted() {
    const globalStore = useGlobal()
    // localization
    this.readLanguageAndCountryFromUrl(globalStore);
    //if (globalStore.$au)
    //this.getAccessoryShopUrl(globalStore);
  },

  created() {
    
  }
};
</script>

<style lang="scss" scoped>
@import "@liebherr/patternlib/dist/patternlib/patternlib.css";  /* should be removed because of cms interaction problems, */
@import "@liebherr/patternlib/www/assets/css/patternlib-fonts.css"; /* but if removed strange behavior of App -> -TODO- */
// @import "bootstrap/dist/css/bootstrap-grid.min.css";

#menuBar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

#menuBar > patternlib-flyoutmenu > patternlib-avatar {
  margin: 10px;
}

#menuBar > patternlib-icon {
  margin: 10px;
  border-radius: 5px;
}


#shadow::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(to right, var(--color-artic-blue) 0px, rgba(0, 0, 0, 0) 5%, rgba(0, 0, 0, 0) calc( 100% - 64px ), var(--color-artic-blue) 100%);
  z-index: 21;
  pointer-events: none;
}

@media only screen and (max-width: 770px) { 
  #scrollBox::-webkit-scrollbar {
    display: none;
  }

  #scrollBox {
    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;
  }
}
</style>

<!--
<style scoped src="../node_modules/@liebherr/patternlib/dist/patternlib/patternlib.css">
</style>
<style scoped src="../node_modules/@liebherr/patternlib/www/assets/css/patternlib-fonts.css">
</style>
-->